import util from '../util'

let controller = 'ClientScopes'
export default {
  GetAll: function (dto) {
    return util.Axios.GetAll(controller, dto)
  },
  Post: function (dto) {
    return util.Axios.Post(controller, dto)
  },
  Put: function (id, dto) {
    return util.Axios.Put(controller, id, dto)
  },
  Delete: function (clientId, scope) {
    // return util.Axios.Delete(controller, id)
    let dto = { clientId: clientId, scope: scope }
    return util.Axios.DeleteAll(controller , dto)
  }
}
